import { render, staticRenderFns } from "./NavigationMenuPromoGroupItemSmall.vue?vue&type=template&id=ba7d3ce4"
import script from "./NavigationMenuPromoGroupItemSmall.vue?vue&type=script&lang=js"
export * from "./NavigationMenuPromoGroupItemSmall.vue?vue&type=script&lang=js"
import style0 from "./NavigationMenuPromoGroupItemSmall.vue?vue&type=style&index=0&id=ba7d3ce4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports